import Vue from 'vue'

import auth from '@websanova/vue-auth/src/v2.js'
import driverAuthBearer from '@websanova/vue-auth/src/drivers/auth/bearer.js'
import driverHttpAxios from '@websanova/vue-auth/src/drivers/http/axios.1.x.js'
import driverRouterVueRouter from '@websanova/vue-auth/src/drivers/router/vue-router.2.x.js'

Vue.use(auth, {
    plugins: {
        http: Vue.axios, // Axios
        router: Vue.router,
    },
    drivers: {
        auth: driverAuthBearer,
        http: driverHttpAxios, // Axios
        router: driverRouterVueRouter,
    },
    options: {
        rolesKey: 'permissions',
        rememberKey: 'auth_remember',
        tokenDefaultKey: 'sellerdeskai-auth',
        stores: ['storage'],
        authRedirect: {name: 'login-form'},
        notFoundRedirect: {name: 'notfound'},
        loginData: {url: 'api/v1/login?notificationOff', method: 'POST', redirect: false},
        registerData: {
            url: 'api/v1/register?notificationOff',
            method: 'POST',
            staySignedIn: true,
            autoLogin: true,
            fetchUser: true
        },
        logoutData: {
            url: 'api/v1/logout?notificationOff',
            method: 'POST',
            redirect: {name: 'login-form'},
            makeRequest: false
        },
        fetchData: {url: 'api/v1/me', method: 'GET', enabled: true},
        refreshData: {url: 'api/v1/refresh', method: 'GET', enabled: false, interval: 20},
        parseUserData: function ({data}) {
            const user = data
            user.permissions = []
            user.privs = []

            if (user.marketplaces.length > 0) {
                user.privs.push('has-marketplace')
            }
            if (user.verified) {
                user.privs.push('is-verified')
            }
            if (user.subscription) {
                user.privs.push('has-subscription')
            }

            return user
        }
    },
})

Vue.auth.priv = function (priv) {
    return Vue.auth.user().privs.includes(priv);
}